import { z } from 'zod';
import {
  TaskStatus,
  DeploymentPipelinesStatus,
} from '@wix/ambassador-document-management-editor-deployments-v1-deployment/types';

export const getDeploymentSchema = z.object({
  deployment: z.object({
    deploymentPipelinesStatus: z.enum([
      DeploymentPipelinesStatus.IN_PROGRESS,
      DeploymentPipelinesStatus.SUCCESS,
      DeploymentPipelinesStatus.ERROR,
    ]),
  }),
});

const taskDescriptionSchema = z.object({
  taskName: z.string(),
  status: z
    .string()
    .transform((value) =>
      value === TaskStatus.SUCCESS ? TaskStatus.SUCCESS : TaskStatus.ERROR
    ),
  description: z
    .string()
    .nullish()
    .transform((value, ctx) => {
      try {
        return value ? JSON.parse(value) : {};
      } catch {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid JSON',
        });
      }

      return value;
    })
    .pipe(z.record(z.string(), z.string())),
});

export const getDeploymentPipelineDescriptionSchema = z.object({
  pipelinesDescription: z.array(
    z.object({
      deploymentPipelineId: z.string(),
      tasksDescriptions: z.array(taskDescriptionSchema),
    })
  ),
});
